module.exports = __webpack_public_path__ + "static/img/foglet.6e3aad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/foglet.png
// module id = J2CO
// module chunks = 0